/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Locked_Collections_DescriptionInputs */



/**
* | output |
* | --- |
* | "Track every card you own, down to the printing, across as many collections as you like." |
*
* @param {Nav_Locked_Collections_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const nav_locked_collections_description = /** @type {((inputs?: Nav_Locked_Collections_DescriptionInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Locked_Collections_DescriptionInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Erfasse jede Karte, die du besitzt, bis auf den Druck genau, in so vielen Sammlungen wie du magst.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Suivez chaque carte que vous possédez, jusqu'à l'impression près, dans autant de collections que vous voulez.")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("记录你拥有的每一张卡，精确到印刷版本，收藏数量不限。")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("記錄你擁有的每一張卡，精確到印刷版本，收藏數量不限。")
	if (locale === "ko") return /** @type {LocalizedString} */ ("원하는 만큼 컬렉션을 만들어 보유한 카드를 인쇄판 단위까지 기록하세요.")
	return /** @type {LocalizedString} */ ("Track every card you own, down to the printing, across as many collections as you like.")
});